import { render } from "./NotasForm.vue?vue&type=template&id=70de28ab&scoped=true"
import script from "./NotasForm.vue?vue&type=script&lang=js"
export * from "./NotasForm.vue?vue&type=script&lang=js"

import "./NotasForm.vue?vue&type=style&index=0&id=70de28ab&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-70de28ab"]])

export default __exports__